
import { Component, Vue } from 'vue-property-decorator';
import { ApiErrorClass, apiErrorList } from '@/resources/error/apiErrorList';
import PageHeaderError from '@/components/PageHeaderError.vue';
import CameraPageHeaderPaidy from '@/components/CameraPageHeaderPaidy.vue';
import { KycOrgConfig } from '@/api/auth';

@Component({
  components: {
    PageHeaderError,
    CameraPageHeaderPaidy
  }
})
export default class Page extends Vue {
  private get apiError(): ApiErrorClass | undefined {
    const code: string = this.$route.params.code || '-1';
    return apiErrorList.find((apiError: ApiErrorClass): boolean => {
      const isCode: boolean = apiError.code === code;
      return isCode;
    });
  }

  private get isPaidy(): boolean {
    return this.$store.getters['auth/isPaidy'];
  }

  private get message(): string {
    if (this.apiError && this.apiError.i18nText) {
      let errorText: string = this.$t(this.apiError.i18nText) as string;

      // kycOrgConfigNameタグがあれば置換
      if (errorText.match(/<kycOrgConfigName>/) !== null) {
        const orgName: string = this.$store.getters['auth/currentLanguageOrgName'];
        errorText = errorText.replace(/<kycOrgConfigName>/, orgName);
      }

      return errorText;
    }

    return this.$t('error.DefaultErrorMessage') as string;
  }
}
